import React, { memo } from 'react';
import DropdownLink from '../../common/dropdown-link';

interface Props {
  isEnabled: boolean;
  isDefault: boolean;
  onEditClick: () => void;
  onDeleteClick: () => void;
  onToggleActiveStatus: () => void;
}

const ThemeMenu: React.FC<Props> = memo(
  ({ isEnabled = false, isDefault = false, onEditClick, onDeleteClick, onToggleActiveStatus }) => {
    const dropdownItems = [
      <span onClick={onDeleteClick}> Delete </span>,
      <span onClick={onToggleActiveStatus}> Turn {isEnabled ? 'Off' : 'On'} </span>
    ];

    return (
      <div className="theme-menu-container">
        <div className="theme-menu-edit-button" onClick={onEditClick}>
          Edit
        </div>
        <div className="theme-menu-seperator" />
        <div className={`dropdown-link-container ${isDefault ? 'disabled' : ''}`}>
          <DropdownLink items={dropdownItems} />
        </div>
      </div>
    );
  }
);

export default ThemeMenu;
